import React, { useEffect, useRef } from 'react';
import { useField } from '@unform/core';
import * as MaterialDesign from 'react-icons/md';
import PropTypes from 'prop-types';

import { Label } from './styles';

export default function Input({
  name,
  label,
  icon,
  size,
  iconStyle,
  children,
  ...rest
}) {
  const inputRef = useRef(null);
  const { fieldName, defaultValue = '', registerField, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  const renderLabel = label || name;

  const Icon = MaterialDesign[icon];

  return (
    <Label htmlFor={fieldName} icon={icon}>
      {error && <span>{error}</span>}

      <input
        name={fieldName}
        ref={inputRef}
        id={fieldName}
        aria-label={fieldName}
        defaultValue={defaultValue}
        {...rest}
      />
      <span>{renderLabel}</span>
      {icon && <Icon size={size} style={iconStyle} />}
      {children}
    </Label>
  );
}

Input.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  icon: PropTypes.string,
  size: PropTypes.number,
  iconStyle: PropTypes.objectOf(PropTypes.any),
  children: PropTypes.element,
};

Input.defaultProps = () => ({
  icon: '',
  label: '',
  size: null,
  iconStyle: null,
  children: null,
});
